var map = {
	"./37-pet.png": 50,
	"./57%.png": 55,
	"./63-pet.png": 51,
	"./65%.png": 34,
	"./67%-hover.png": 229,
	"./67%.png": 230,
	"./72%.png": 48,
	"./77%.png": 53,
	"./87%.png": 46,
	"./99%.png": 231,
	"./Adobe-mobile.png": 79,
	"./Adobe.png": 84,
	"./GLOBE_LOOP.gif": 64,
	"./Group 42.png": 93,
	"./Rev_5.gif": 73,
	"./SQUARESPACE-mobile.png": 232,
	"./SQUARESPACE.png": 233,
	"./Screenshot from 2024-08-12 18-39-43.png": 234,
	"./Screenshot from 2024-08-12 18-39-49.png": 235,
	"./Screenshot from 2024-08-12 18-39-53.png": 236,
	"./Shopify-mobile.png": 237,
	"./Shopify.png": 238,
	"./What-is-Wix-eCommerce.png": 239,
	"./Wix-mobile.png": 240,
	"./Wix.png": 241,
	"./Wix_eCommerce.png": 242,
	"./adidas-mobile.png": 81,
	"./adidas.png": 86,
	"./ali_express_transparent.png": 102,
	"./aliexpress_logo_icon_247663.webp": 243,
	"./amazon_ss.png": 244,
	"./amazon_transparent.png": 103,
	"./analysis.png": 245,
	"./analysis_combined.png": 101,
	"./bag.png": 246,
	"./bailly_transparent.png": 104,
	"./banner img.png": 105,
	"./banner-bg.png": 247,
	"./banner-bg1.png": 248,
	"./banner.png": 249,
	"./beauty.png": 47,
	"./bg-login.png": 250,
	"./bg-step.png": 251,
	"./boltnation.png": 252,
	"./checked_icon.png": 100,
	"./cocacola-mobile.png": 77,
	"./cocacola.png": 82,
	"./code-hover.png": 253,
	"./computer.png": 57,
	"./crazycompression.png": 254,
	"./dollar.png": 255,
	"./electronics.png": 49,
	"./endrizzi.png": 256,
	"./enohdesigns.png": 257,
	"./footer-bg.png": 258,
	"./footer-border.png": 30,
	"./furniture.png": 54,
	"./globe.png": 259,
	"./glogin.png": 260,
	"./grid-white.png": 58,
	"./header.png": 261,
	"./hori-dotted.png": 262,
	"./household.png": 56,
	"./hover-img1.png": 263,
	"./human.png": 74,
	"./icon_step_1.png": 94,
	"./icon_step_2.png": 95,
	"./icon_step_3.png": 96,
	"./integration.png": 264,
	"./jacket.png": 45,
	"./javascript-mobile.png": 265,
	"./javascript.png": 266,
	"./jhinton.png": 267,
	"./line.png": 268,
	"./logo-black.png": 37,
	"./logo-black1.png": 269,
	"./logo-error.png": 270,
	"./logo-success.png": 271,
	"./logo.png": 43,
	"./logo1.png": 272,
	"./mobile-integration.png": 273,
	"./mobile-integration1.png": 274,
	"./nike-mobile.png": 80,
	"./nike.png": 85,
	"./p1 copy 3.png": 275,
	"./p1 copy.png": 276,
	"./p1.png": 277,
	"./pet.png": 52,
	"./priya_ai.png": 75,
	"./priya_banner.png": 278,
	"./product-analyses.png": 92,
	"./products.png": 279,
	"./products1.png": 280,
	"./puffieslippers.png": 281,
	"./revenue-old.png": 282,
	"./revenue.png": 283,
	"./reverse.png": 284,
	"./separator.png": 285,
	"./setupShopify/Screenshot_1.png": 286,
	"./setupShopify/Screenshot_2.png": 287,
	"./setupShopify/Screenshot_3.png": 288,
	"./setupShopify/Screenshot_4.png": 289,
	"./setupShopify/Screenshot_5.png": 290,
	"./setupShopify/Screenshot_6.png": 291,
	"./setupShopify/Screenshot_7.png": 292,
	"./setupShopify/Screenshot_8.png": 293,
	"./setupShopify/Step2.png": 294,
	"./setupShopify/Step3.png": 295,
	"./setupShopify/Step4.png": 296,
	"./setupShopify/Step6.png": 297,
	"./setupShopify/Step7.png": 298,
	"./setupShopify/Step8.png": 299,
	"./setupShopify/Step9.png": 300,
	"./setupShopify/Tab1-img.png": 301,
	"./setupShopify/setupShopify_1.png": 302,
	"./setupShopify/setupShopify_2.png": 303,
	"./setupShopify/setupShopify_3.png": 304,
	"./setupShopify/setupShopify_4.png": 305,
	"./setupShopify/setupShopify_5.png": 306,
	"./setupShopify/setupShopify_6.png": 307,
	"./setupShopify/setupShopify_7.png": 308,
	"./setupShopify/setupShopify_8.png": 309,
	"./shopbypearl.com.png": 310,
	"./shopify-img.png": 311,
	"./shopify-shop-launch.png": 312,
	"./shopify_transparent.png": 106,
	"./slide1.jpg": 60,
	"./slide2.jpg": 61,
	"./slide2.webp": 313,
	"./slide22.png": 314,
	"./slide3.webp": 62,
	"./slide4.webp": 63,
	"./southern-mobile.png": 78,
	"./southern.png": 83,
	"./square-img.png": 315,
	"./step-beauty.png": 316,
	"./step-electronics.png": 317,
	"./step-jacket.png": 318,
	"./step1-img1.png": 319,
	"./step1-img2.png": 320,
	"./step3-hover.png": 321,
	"./step3-img.png": 322,
	"./step_1_image.png": 97,
	"./step_1_image_.png": 323,
	"./step_2_image.png": 98,
	"./step_2_image_.png": 324,
	"./step_3_image.png": 99,
	"./step_3_image_.png": 325,
	"./streetcrafter.png": 326,
	"./tryacaps.png": 327,
	"./vert-dotted.png": 328,
	"./walmart_transparent.png": 107,
	"./watch-mobile1.png": 329,
	"./watch-mobile2.png": 330,
	"./watch.png": 331,
	"./wix-img.png": 332,
	"./works-bg.png": 333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;